/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Set New Password View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './setNewPasswordView';

export const mapStateToPropsSetNewPassword = mapStateToProps;
export const mapDispatchToPropsSetNewPassword = mapDispatchToProps;

export default connect(
  mapStateToPropsSetNewPassword,
  mapDispatchToPropsSetNewPassword
)(View);
